import { render, staticRenderFns } from "./AdminAlgorithms.vue?vue&type=template&id=3b95a0a5&"
import script from "./AdminAlgorithms.vue?vue&type=script&lang=js&"
export * from "./AdminAlgorithms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports